export const API_DOMAIN =
  process.env.REACT_APP_NODE_ENV === "production"

    ? process.env.REACT_APP_DOMAIN

    : "http://localhost:8080";
    // : " https://a9a7-2405-201-7-4873-4564-afef-3958-113f.ngrok-free.app";
